import { render, staticRenderFns } from "./SessionHistory.vue?vue&type=template&id=70e17ca0&scoped=true"
import script from "./SessionHistory.vue?vue&type=script&lang=js"
export * from "./SessionHistory.vue?vue&type=script&lang=js"
import style0 from "./SessionHistory.vue?vue&type=style&index=0&id=70e17ca0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e17ca0",
  null
  
)

export default component.exports